import { globalErrorHandler } from '@/utils'

import { cloneProvider } from '@/components/services/providers/utils'

import render from './render'

export default {
  name: 'CloneButton',

  props: {
    provider: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    }
  },

  data() {
    return {
      loading: false,
      showConfirmDialog: false
    }
  },

  methods: {
    async cloneProvider() {
      try {
        this.loading = true
        const response = await cloneProvider(this.provider)
        if (response) {
          this.$emit('clone', response.id)
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
